export const isInStandalone = () =>
  ('standalone' in window.navigator && !!window.navigator.standalone) ||
  !!window.matchMedia?.('(display-mode: standalone)').matches
